export const STAGING_URL: string = 'https://staging-th-admin.rbi.tools';
export const PREVIEW_URL: string = 'previewUrl';
export const SHOULD_REDIRECT_TO_PREVIEW: string = 'shouldRedirectToPreview';
export const REDIRECTED_FROM_STAGING: string = 'redirectedFromStaging';
export const SHOULD_LOGIN_WITH_OKTA: string = 'shouldLoginWithOkta';
